import { PageFactory } from './pageFactory';

import type {
  PageEntity,
  PagePropsPub,
  PagePropsPvt,
} from './pageEntity';
import type { PageIRepository } from './pageIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { PageJsonPub, PageJsonPvt } from '@/types/domain/childNotebook/entities/pageEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * ページレポジトリ
 */
export class PageRepository extends AppsyncRepository<
  PageEntity,
  PagePropsPvt,
  PageJsonPvt,
  PagePropsPub,
  PageJsonPub
> implements PageIRepository {
  private factory = new PageFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryChildNotebookPageEntity;
    return name;
  }

  /**
   * Entityを生成
   * @param props データ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
